module.exports = __webpack_public_path__ + "static/media/dm.395b272f.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/dm.svg
// module id = 2078
// module chunks = 0